import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../home/Navbar";
import healthIcon from "../assets/horoscopeicons/health.png";
import careerIcon from "../assets/horoscopeicons/career.png";
import familyIcon from "../assets/horoscopeicons/family.png";
import financeIcon from "../assets/horoscopeicons/finances.png";
import physiqueIcon from "../assets/horoscopeicons/physique.png";
import relationshipIcon from "../assets/horoscopeicons/relationship.png";
import statusIcon from "../assets/horoscopeicons/status.png";
import totalScoreIcon from "../assets/horoscopeicons/totalscore.png";
import travelIcon from "../assets/horoscopeicons/travel.png";
import friendsIcon from "../assets/horoscopeicons/friends.png";
import Queryform from "./Queryform";
import Footer from "../home/Footer";
import { API_END_POINT } from "./Utils/Constant";
import Loader from "./Loader";

const DailyHoroscope = () => {
    // API Endpoints for each zodiac
     const zodiacAPIEndpoints = {
        Aries: `${API_END_POINT}predictions/daily-aries`,
        Taurus: `${API_END_POINT}predictions/daily-taurus`,
        Gemini: `${API_END_POINT}predictions/daily-gemini`,
        Cancer: `${API_END_POINT}predictions/daily-cancer`,
        Leo: `${API_END_POINT}predictions/daily-leo`,
        Virgo: `${API_END_POINT}predictions/daily-virgo`,
        Libra: `${API_END_POINT}predictions/daily-libra`,
        Scorpio: `${API_END_POINT}predictions/daily-scorpio`,
        Sagittarius: `${API_END_POINT}predictions/daily-sagittarius`,
        Capricorn: `${API_END_POINT}predictions/daily-capricorn`,
        Aquarius: `${API_END_POINT}predictions/daily-aquarius`,
        Pisces: `${API_END_POINT}predictions/daily-pisces`,
    };

    const [currentHoroscope, setCurrentHoroscope] = useState(null);
    const [selectedZodiac, setSelectedZodiac] = useState("");
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    // Function to fetch data for a specific zodiac sign
    const fetchZodiacData = async (zodiacSign) => {
        try {
            setLoading(true);
            const response = await fetch(zodiacAPIEndpoints[zodiacSign]);
            const data = await response.json();
            setCurrentHoroscope(data);
        } catch (error) {
            console.error(`Error fetching ${zodiacSign} horoscope:`, error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Set initial zodiac sign from location state or default to Aries
        const initialZodiac = location.state?.zodiacSign || "Aries";
        setSelectedZodiac(initialZodiac);
        fetchZodiacData(initialZodiac);
    }, [location.state?.zodiacSign]);

    // Handle zodiac sign selection
    const handleZodiacSelect = (zodiacSign) => {
        setSelectedZodiac(zodiacSign);
        fetchZodiacData(zodiacSign);
    };

    // Handle dropdown selection
    const handleZodiacChange = (event) => {
        const selected = event.target.value;
        handleZodiacSelect(selected);
    };

    if (loading) {
        return <div className='flex justify-center items-center h-screen'>
      <Loader />
    </div>;
    }

    const zodiacSigns = Object.keys(zodiacAPIEndpoints);

    return (
        <>
            <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
                <Navbar />
                <h1 className="text-4xl font-bold text-center font-serif text-secondary mt-6 sm:mb-2">DAILY HOROSCOPE</h1>
                <p className="text-lg mb-4 font-serif p-2 text-secondary text-center mx-auto max-w-2xl">
                    Kickstart your day with this horoscope to align your energy, seize new opportunities, and gain insight into any challenges that might arise.
                </p>

                {/* Zodiac Dropdown (Visible only on small screens) */}
                <div className="sm:hidden px-4 mt-4">
                    <label htmlFor="zodiac-select" className="block text-lg font-semibold text-center text-secondary mb-2">
                        Select Zodiac Sign:
                    </label>
                    <select
                        id="zodiac-select"
                        value={selectedZodiac}
                        onChange={handleZodiacChange}
                        className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-secondary"
                    >
                        {zodiacSigns.map((sign) => (
                            <option key={sign} value={sign}>
                                {sign}
                            </option>
                        ))}
                    </select>
                </div>

                <main className="md:w-4/5 lg:w-4/5 sm:w-full mx-auto flex flex-col lg:flex-row gap-6 lg:gap-12">
                    {/* Sidebar (Hidden on small screens) */}
                    <aside className="w-full lg:w-1/4 bg-slate-200 shadow-lg p-4 mt-6 h-fit sticky top-2 lg:block hidden">
                        <h2 className="text-xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">
                            Zodiac Signs
                        </h2>
                        <ul className="space-y-2">
                            {zodiacSigns.map((sign) => (
                                <li
                                    key={sign}
                                    className={`cursor-pointer p-3 rounded-md font-semibold text-center ${
                                        sign === selectedZodiac 
                                            ? 'bg-gradient-to-r from-success to-[#9034E9] text-white' 
                                            : 'text-gray-800 hover:bg-gray-200'
                                    }`}
                                    onClick={() => handleZodiacSelect(sign)}
                                >
                                    {sign}
                                </li>
                            ))}
                        </ul>
                    </aside>

                    {/* Main Horoscope Details */}
                    <div className="w-full lg:w-3/4 lg:p-6 md:p-6 p-1 sm:p-2 sm:mt-6">
                        {currentHoroscope && (
                            <div className="bg-gradient-to-r from-white to-success/40 shadow-lg rounded-lg lg:p-6 md:p-6 p-1 sm:p-3 mb-6">
                                <h1 className="text-3xl font-bold text-center bg-gradient-to-r from-success to-[#9034E9] rounded-md text-white p-2">
                                    {selectedZodiac} Horoscope
                                </h1>
                                <div className="flex items-center justify-center space-x-6 mt-4 text-lg">
                                    <p className="font-semibold">
                                        Lucky Color:{" "}
                                        <span className="uppercase">
                                            {currentHoroscope.prediction.response?.lucky_color || "N/A"}
                                        </span>
                                    </p>
                                    <p className="font-semibold">
                                        Lucky Numbers: {currentHoroscope.prediction.response?.lucky_number?.join(", ") || "N/A"}
                                    </p>
                                </div>

                                {/* Horoscope Details Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 mt-6">
                                    {Object.entries(currentHoroscope.prediction.response?.bot_response || {}).map(([key, value]) => {
                                        const iconMap = {
                                            health: healthIcon,
                                            family: familyIcon,
                                            friends: friendsIcon,
                                            travel: travelIcon,
                                            career: careerIcon,
                                            relationship: relationshipIcon,
                                            finances: financeIcon,
                                            physique: physiqueIcon,
                                            status: statusIcon,
                                            total_score: totalScoreIcon,
                                        };
                                        return (
                                            <div key={key} className="bg-gray-100 p-4 rounded-md shadow-md flex items-start space-x-4">
                                                <img src={iconMap[key]} alt={key} className="w-10 h-10 items-center" />
                                                <div>
                                                    <h3 className="text-lg font-semibold text-gray-900 capitalize">{key.replace("_", " ")}</h3>
                                                    <p className="text-gray-700">{value?.split_response || "No data available"}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </main>

                <Queryform />
                <Footer />
            </section>
        </>
    );
};

export default DailyHoroscope;
